export default __webpack_public_path__ + "static/media/330_store01-en-web.94fb802c.png";